import React from 'react';
import PropTypes from 'prop-types';

import {
    Form,
    Field,
} from 'redux-form';

import TextField from 'components/forms/components/TextField';
import TextareaField from 'components/forms/components/TextareaField';
import DateField from 'components/forms/components/DateField';

import Loader from './Loader';
import CheckoutMessage from './CheckoutMessage';

import CartItemContainer from '../containers/CartItemContainer';

import {
    totalPriceOfProductsInCart,
} from '../helpers';

const Checkout = (props) => {
    const {
        productsLoaded,
        cart,
        handleSubmit,
        submitting,
        submitFailed,
        submitSucceeded,
    } = props;

    if (productsLoaded === false) {
        return <Loader />;
    }

    if (submitFailed) {
        return (
            <CheckoutMessage>
                Oeps er ging iets mis.. Stuur ons een mailtje en we bekijken het probleem.
            </CheckoutMessage>
        );
    }

    if (submitSucceeded) {
        return (
            <CheckoutMessage>
                Je bestelling is geplaatst, we sturen je zo snel mogelijk een bevestiging
            </CheckoutMessage>
        );
    }

    return (
        <div className="checkout">
            <div className="checkout-cart cart">
                <h2 className="with-margin">Winkelmandje</h2>
                <div className="cart__details">
                    {Object.values(cart).map(cartItem => (
                        <CartItemContainer
                            productSlug={cartItem.productSlug}
                            amount={cartItem.amount}
                        />
                    ))}
                </div>
                <div className="cart__total">
                    totaal <strong>€{totalPriceOfProductsInCart(cart)}</strong>
                </div>
            </div>
            <div className="checkout-form">
                <h2 className="with-margin">Bestelgegevens</h2>
                <Form className="form" onSubmit={handleSubmit}>
                    <Field label="Volledige naam" name="name" component={TextField} />
                    <Field label="Adres" name="address" component={TextareaField} />
                    <Field label="E-mail" name="email" component={TextField} type="email" />
                    <Field label="Telefoon" name="phone" component={TextField} />
                    <Field label="Afhaaldatum" name="pickupDate" component={DateField} />
                    <Field label="Opmerkingen" name="remarks" component={TextareaField} />
                    <div className="form-actions">
                        {submitting && <Loader />}
                        {submitting === false && <button className="button">Bestel</button>}
                    </div>
                </Form>
            </div>
        </div>
    );
};

Checkout.propTypes = {
    productsLoaded: PropTypes.bool.isRequired,
    cart: PropTypes.shape({}).isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitFailed: PropTypes.bool.isRequired,
    submitSucceeded: PropTypes.bool.isRequired,
};

export default Checkout;



// WEBPACK FOOTER //
// ./resources/components/shop/components/Checkout.jsx